import type { ModuleVersionInstance } from '@modules/artifactfeeds'

import type { HostedModule } from '../gateways.interface'

export function mapModuleVersionInstanceToHostedModule(instance: ModuleVersionInstance): HostedModule {
  return {
    name: instance.name,
    version: instance.version,
    description: '',
    feedProtocol: instance.technology,
    feedType: 'Public',
    moduleVersionInstanceId: instance.moduleVersionInstanceId,
  }
}
